import qs from 'query-string'
import Cookies from 'js-cookie'
import { POST, Uuid } from '@sisyphe/utils'

export const phoneValidator = async (rule, value) => {
  if (!/^1[3-9]\d{9}$/.test(value.mobile))
    throw new Error('请输入正确的手机号码')
}

// 密码等级检验
export const checkPassWord = value => {
  // let tests = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8}/
  // return tests.test(value)

  /* 2023年7月14日更新了安全等级算法 */
  const regs = [/[a-z]/, /[A-Z]/, /\d/, /[!@#$%&*^]/]
  const count = regs.reduce((t, r) => t + r.test(value), 0)
  return count >= 3
}

export const clearAllCookies = () => {
  let keys = Object.keys(Cookies.get())
  keys.forEach(function (item) {
    Cookies.remove(item, { path: '/' })
  })
}

export const getApplication = () => {
  let sessionStorage = window.sessionStorage.search
  let queryData = qs.parse(sessionStorage)

  return queryData?.applicationCode || 'admin'
}

// 登录之后该往哪儿跳转
export const loginRedirectUrl = (back_url = '') => {
  const { SSO_URL, S3_URL } = process.env
  const search = window.sessionStorage.getItem('search')
  let { url, ...objSearch } = qs.parse(search)
  /**
   * ssourl 为登录成功跳转处理会话地址
   * backUrl 为成功获取token后该跳向何处
   * state 包含台号站点以及零售端标识
   */
  const ssourl = `${SSO_URL}/redirect-result`
  const backUrl = back_url || `${S3_URL}`
  // 没有业务系统时跳向自己获取会话的地址
  let redirect_url =
    url || `${ssourl}?redirectUrl=${encodeURIComponent(backUrl)}`

  /**
   * 解析地址栏参数：
   *   把除了url和applicationCode以及state的参数全部做解析传输
   *   获取地址栏参数分析是否存在any参数如果存在就不重新设置
   *   避免passpord没登陆时出现两个any参数
   */
  let querys = []
  let decUrlData = qs.parse(decodeURIComponent(url))
  for (let key in objSearch) {
    // 保证值不能为 state 和 applicationCode 不然会出现后端不能解析的问题
    ![
      'state',
      'applicationCode',
      'clientId',
      'scope',
      'protocol',
      'param',
      'responseType',
    ].includes(key) &&
      !decUrlData.any &&
      querys.push(`${key}-${objSearch[key]}`)
  }
  if (querys.length) {
    redirect_url = appendQuery(redirect_url, { any: querys.join(',') })
  }

  return redirect_url
}

export const appendQuery = (url, query) => {
  url = url.includes('?') ? `${url}&` : `${url}?`
  return url + qs.stringify(query)
}

const whiteList = [/sisyphe\.(top|tech)/, /localhost/, /172/]

export const validHost = function (back_url) {
  back_url = back_url.replace('http://', '')
  back_url = back_url.replace('https://', '')
  const host = back_url.split('/')[0]
  return whiteList.some(reg => reg.test(host))
}

export const onGeetest = () => {
  return new Promise(async (resolve, reject) => {
    let { data } = await POST('/api/sensebot/register', {
      app: 'passport',
      scene: 'login',
    })
    window.initGeetest(
      {
        gt: data.gt,
        challenge: data.challenge,
        offline: !data.success, // 表示用户后台检测极验服务器是否宕机
        new_captcha: data.new_captcha, // 用于宕机时表示是新验证码的宕机
        product: 'bind', // 产品形式，包括：float，popup
        width: '300px',
      },
      captchaObj => {
        captchaObj
          .onReady(() => {
            captchaObj.verify() // 显示验证码窗口
            captchaObj.onClose(() => resolve())
          })
          .onSuccess(() => {
            let result = captchaObj.getValidate()
            resolve(result)
          })
          .onError(() => {
            reject()
          })
      }
    )
  })
}

export function getLocalhostDeviceId() {
  let deviceIdFromLocalStorage = window.localStorage.getItem('DEVICE_ID')
  // 如果本地不存在设备ID，则新建一个设备ID并保存到本地
  if (!deviceIdFromLocalStorage) {
    deviceIdFromLocalStorage = Uuid()
    window.localStorage.setItem('DEVICE_ID', deviceIdFromLocalStorage)
  }
  return deviceIdFromLocalStorage
}
